module.exports = __webpack_public_path__ + "static/logo-67ef9f52b5c9f0d01df0aed5f019c33b.png";